import { Helmet } from 'react-helmet-async';
import Hero from './sections/Hero';
import SpeedComparison from './sections/SpeedComparison';
import WhatIsRealTimePoR from './sections/WhatIsRealTimePoR';
import UseCases from './sections/UseCases';
import OutputsAndLiveDemo from './sections/OutputsAndLiveDemo';
import Integrations from './sections/Integrations';
import LeadingAtIntersection from './sections/LeadingAtIntersection';
import Faq from './sections/Faq';
import FinalCTA from './sections/FinalCTA';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Audit Financier - Real-Time Proof of Reserves</title>
        <meta name="description" content="Transparency reporting at the speed of innovation. Real-time attestation reporting with 24/7 monitoring and instant verification." />
      </Helmet>

      <div className="home-page">
        <Hero />
        <SpeedComparison />
        <WhatIsRealTimePoR />
        <UseCases />
        <OutputsAndLiveDemo />
        <Integrations />
        <LeadingAtIntersection />
        <Faq />
        <FinalCTA />
      </div>
    </>
  );
};

export default Home;
